import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { connect } from "react-redux";

import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { Admin } from "../../../Entity/Entities/Person/Role/Roles/Admin";
import { User } from "../../../Entity/Entities/Person/Role/Roles/User";

class Users extends Component {
  // protected shouldClearBeforeUnmounting: boolean = true;
  // protected clearWith: string = Constants.PAGE_SETTINGS_USER_PROFILE_CLEAR;
  protected selectedPerson: PersonInterface;
  protected user: PersonInterface = this.props.app?.persons
                                      .find(person => person?.id === this.props.app?.session?.user?.id);

  public state = {
    isDeleteUserPopupOpen: false,
    selectedUser: null,
    anchorEl: null
  };

  constructor(public props) {
    super(props);

    this.getUsers = this.getUsers.bind(this);
  }

  public deleteUser = (user: PersonInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_PERSON_DELETE_START,
      payload: {
        person: user
      }
    });
  }

  protected openMenu = (event: any, person: PersonInterface): void => {
    this.selectedPerson = person;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getUsers(): any {
    return this.props.app.persons
      .filter((person: PersonInterface) => !!person &&
                                           !person.removed &&
                                           !person.createdBySystem &&
                                           person.role && 
                                           ((person.role.getRoleId() === User.contactRoleId) || (person.role.getRoleId() === Admin.contactRoleId)))
      .sort((person1: PersonInterface, person2: PersonInterface) => {
        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return 1;
        }

        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return -1;
        }

        return  0;
      })
      .map((person: PersonInterface, key: number) => {
        return (
          <TableRow
            hover
            key={key}
            className={`clickable-entity`}
            onClick={() => {
              this.redirect(`/app/user/update/${person.id}`);
            }}
          >
            <TableCell style={{width: "50px"}}>
              {person.renderAvatar()}
            </TableCell>
            <TableCell>{person.displayName}</TableCell>
            <TableCell>
              <Chip label={person.role.getName()}></Chip>
            </TableCell>
            <TableCell>{person.email}</TableCell>
            <TableCell>
              {
                person?.isAccountConfirmed && (
                  <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="list-label creation-type-label green">
                      {this.trans("status-confirmed").toLowerCase()}
                    </div>
                  </div>
                  
                )
              }
              {
                !person?.isAccountConfirmed && (
                  <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="list-label creation-type-label red">
                      {this.trans("status-not-confirmed").toLowerCase()}
                    </div>
                  </div>
                  
                )
              }
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, person)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedPerson && this.selectedPerson.id === person.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  {!!this.selectedPerson && this.user.role && this.user.role.getRoleId() === User.contactRoleId && (
                    <MenuItem
                      onClick={() => this.redirect(`/app/user/update/${this.selectedPerson.id}`)}
                    >
                      <ListItemIcon><div className="icon icon-ic-eye aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menu/user-option/view")}</ListItemText>
                    </MenuItem>
                  )}
                  {!!this.selectedPerson && this.user.role && this.user.role.getRoleId() === Admin.contactRoleId && (
                    <MenuItem
                      onClick={() => this.redirect(`/app/user/update/${this.selectedPerson.id}`)}
                    >
                      <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                    </MenuItem>
                  )}
                  {!!this.selectedPerson && this.user.role && this.user.role.getRoleId() === Admin.contactRoleId && (
                    <MenuItem
                      className="delete-action"
                      onClick={() => this.setState({isDeleteUserPopupOpen: true, selectedUser: this.selectedPerson, anchorEl: null})}
                    >
                      <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public render() {
    return (
      <div style={{width: "100%"}}>
        <div className="component-wrapper no-margin-top no-margin-right">
          <Card className="card no-padding">
            <div className="label-container" style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
              <div style={{flexDirection: "column"}}>
                <h3 className="card-title">
                  {this.trans("title-users")}
                </h3>
              </div>
              {this.user.role && this.user.role.getRoleId() === 6 && (
                <div className="button-container">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.redirect('/app/user/create')}
                    style={{marginRight: "25px"}}
                  >
                    {this.trans("button-add-user")}
                  </Button>
                </div>
              )}
            </div>
            <div className="table-container">
              <TableComponent
                {...this.props}
                paginator={{
                  name: "Users",
                  path: this.props.app.paginator
                }}
                dispatch={this.props.dispatch}
                headers={[
                  "", this.trans("label-name"), this.trans("role"), this.trans("title-email"), "", ""
                ]}
                entities={this.props.app.persons}
                className="listing-table users-listing-table"
                rows={this.getUsers()}
              />
            </div>
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-user")}
          content={this.trans("you-are-about-to-delete-user",
            {
              role: this.state.selectedUser && this.state.selectedUser.role ? this.state.selectedUser.role.getName() : "",
              name: this.state.selectedUser ? `${this.state.selectedUser.firstName} ${this.state.selectedUser.lastName}` : ""
            })
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteUserPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteUserPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteUserPopupOpen: false }, this.deleteUser(this.state.selectedUser)); }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.users,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    Users
);
